import React, { useContext } from 'react'
import { isMobile } from 'react-device-detect'
import { PublicIndexContext } from '../context/PublicIndexContext'

const Header = () => {
  const publicIndexContext = useContext(PublicIndexContext)
  if (isMobile) {
    switch (publicIndexContext.organizationData.positionOfLogo) {
    case 'left':
      return (
        <div className="container" style={publicIndexContext.style.header}>
          <div className="row">
            <div className="col offset-0">
              <img className="img-fluid logo" src={publicIndexContext.organizationData.logo} alt="" />
            </div>
          </div>
        </div>
      )
    case 'center':
      return (
        <div className="container" style={publicIndexContext.style.header}>
          <div className="row">
            <div className="col offset-1">
              <img className="img-fluid logo" src={publicIndexContext.organizationData.logo} alt="" />
            </div>
          </div>
        </div>
      )
    case 'right':
      return (
        <div className="container" style={publicIndexContext.style.header}>
          <div className="row">
            <div className="col offset-4">
              <img className="img-fluid logo" src={publicIndexContext.organizationData.logo} alt="" />
            </div>
          </div>
        </div>
      )
    default:
      return (
        <div className="container" style={publicIndexContext.style.header}>
          <div className="row">
            <div className="col offset-0">
              <img className="img-fluid logo" src={publicIndexContext.organizationData.logo} alt="" />
            </div>
          </div>
        </div>
      )
    }
  } else {
    switch (publicIndexContext.organizationData.positionOfLogo) {
    case 'left':
      return (
        <div className="container" style={publicIndexContext.style.header}>
          <div className="d-flex justify-content-start">
            <img className="img-fluid logo" src={publicIndexContext.organizationData.logo} />
          </div>
        </div>
      )
    case 'center':
      return (
        <div className="container" style={publicIndexContext.style.header}>
          <div className="d-flex justify-content-center">
            <img className="img-fluid logo" src={publicIndexContext.organizationData.logo} />
          </div>
        </div>
      )
    case 'right':
      return (
        <div className="container" style={publicIndexContext.style.header}>
          <div className="d-flex justify-content-end">
            <img className="img-fluid logo" src={publicIndexContext.organizationData.logo} />
          </div>
        </div>
      )
    default:
      return (
        <div className="container" style={publicIndexContext.style.header}>
          <div className="row">
            <div className="col">
              <img className="img-fluid logo" src={publicIndexContext.organizationData.logo} alt="" />
            </div>
            <div className="col"></div>
            <div className="col"></div>
          </div>
        </div>
      )
    }
  }
}

export default Header
